'use strict';

var ServiceDateRangeLevelChartFilterFactory = function ServiceDateRangeLevelChartFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['ServiceDemandClassFilterFactory', 'ServiceDemandDowFilterFactory', 'ServiceDemandNumberOfStopsFilterFactory', 'ServiceDemandTimeOfDayFilterFactory', 'MarketPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function ServiceDateRangeLevelChartFilter() {
    DemandFilter.call(this, 'service', 'date-range-level-chart');
    this.registerFilters(injectedFilters);
  }
  ServiceDateRangeLevelChartFilter.constructor = ServiceDateRangeLevelChartFilter;
  ServiceDateRangeLevelChartFilter.prototype = Object.create(DemandFilter.prototype);
  return ServiceDateRangeLevelChartFilter;
};
ServiceDateRangeLevelChartFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = ServiceDateRangeLevelChartFilterFactory;